import { Logger, LoggerService } from '@Shared/logger';
import { Pipeline, PipelineContext, PipelineStep } from './_base';
import { Bus, EventModule } from '@Modules/event_module';
import { APP_EVENTS } from '@Core';

export class PipelineModuleClass {
  private Logger: Logger = LoggerService.createLogger('PipelineModule');

  private context: PipelineContext = {};

  constructor() {
    this.Logger.trace('****  CTOR ****');
  }

  getContext(): PipelineContext {
    return this.context;
  }

  updateContext(newContext: PipelineContext): void {
    this.context = { ...this.context, ...newContext };
  }

  async startPipeline(initialStep: PipelineStep): Promise<void> {
    const pipeline = new Pipeline();

    this.Logger.trace('startPipeline');

    await pipeline.execute(initialStep, this.context);

    this.Logger.trace('endPipeline', this.context);
    Bus.emit(APP_EVENTS.onReady, {
      auth: this.context.checkAuthStatus,
      entitlement: this.context?.checkEntitlements,
    });
    const durations = EventModule.PerfTracker.getAllDurations();
    this.Logger.trace('Plugin Initialization Durations', durations);
    EventModule.PerfTracker.removeTrackBetween('appInit');
  }

  async startUserInitiatedAuthPipeline(
    initialStep: PipelineStep,
    showEntitlementCheckScreen: boolean = false,
  ): Promise<PipelineContext> {
    const pipeline = new Pipeline();

    this.Logger.trace('startUserInitiatedAuthPipeline');
    const isAuthFromPayway = this.context.isAuthFromPayway;
    this.context = { isAuthFromPayway }; // Reset the context for a new pipeline
    this.context.showEntitlementCheckScreen = showEntitlementCheckScreen;
    await pipeline.execute(initialStep, this.context);

    const durations = EventModule.PerfTracker.getAllDurations();
    this.Logger.trace(
      'startUserInitiatedAuthPipeline Finished',
      this.context,
      durations,
    );
    return this.context;
  }
}

export const PipelineModule = new PipelineModuleClass();
